// Shapes the org-scoped exam structure response for the pages that draw it.
//
// GET /organizations/{orgId}/exams/{examId}/structure returns
//   { examId, sections: [{ ...section, questionCount, topics: [{ ...topic, questionCount }] }],
//     countsByTopic: { topicId: n }, totalQuestions, topicCount }
// The server does the counting; this only guards against missing pieces so a
// partial payload renders as an empty tree rather than crashing a page.

function count(value) {
  return Number.isFinite(value) && value >= 0 ? value : null;
}

export function normalizeExamStructure(payload) {
  const rawSections = Array.isArray(payload?.sections) ? payload.sections : [];
  const sections = rawSections
    .filter((section) => section?.id)
    .map((section) => ({
      ...section,
      topics: (Array.isArray(section.topics) ? section.topics : []).filter((topic) => topic?.id)
    }));

  // Prefer the server's per-topic counts; fall back to each topic's own count.
  const countsByTopic = {};
  sections.forEach((section) => {
    section.topics.forEach((topic) => {
      const n = count(topic.questionCount);
      if (n != null) countsByTopic[topic.id] = n;
    });
  });
  const serverCounts = payload?.countsByTopic;
  if (serverCounts && typeof serverCounts === 'object') {
    Object.entries(serverCounts).forEach(([topicId, n]) => {
      if (count(n) != null) countsByTopic[topicId] = n;
    });
  }

  const listedTopics = sections.reduce((total, section) => total + section.topics.length, 0);
  const summedQuestions = Object.values(countsByTopic).reduce((total, n) => total + n, 0);

  return {
    sections,
    countsByTopic,
    totalQuestions: count(payload?.totalQuestions) ?? summedQuestions,
    topicCount: count(payload?.topicCount) ?? listedTopics
  };
}
